import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { motion, useInView } from "framer-motion";
import { useMediaQuery } from "@mui/material";

const checkIcon = <CheckCircleIcon color="primary" sx={{ mr: 1 }} />;

export default function Integration() {
  const insightsRef = useRef(null);
  const integrationRef = useRef(null);
  const restaurantRef = useRef(null);
  const [ismedium, setIsmedium] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    const checkWidth = () => {
      setIsmedium(window.innerWidth === 768);
    };
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const inViewInsights = useInView(insightsRef, { once: true, amount: 0.2 });
  const inViewIntegration = useInView(integrationRef, {
    once: true,
    amount: 0.2,
  });
  const inViewRestaurant = useInView(restaurantRef, {
    once: true,
    amount: 0.2,
  });

  const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
  };

  return (
    <Box
      sx={{
        backgroundImage: 'url("/assets/reservation/workbg.svg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        borderRadius: 3,
        mt: 4,
        py: { xs: 4, sm: 4 },
        px: { xs: 2, sm: 4, md: 10 },
        mx: { xs: 2, sm: 2 },
      }}
    >
      <Box mb={{ xs: 2, sm: 6 }} ref={insightsRef}>
        <Typography variant="h1" sx={{ color: "#F68528", fontWeight: 700 }}>
          Seamless Integration {isMobile ? " " : <br />} with Egora Ecosystem
        </Typography>
        <Grid container spacing={3} alignItems="center" mt={{ xs: 0, sm: 2 }}>
          <Grid item xs={12} md={6}>
            <motion.img
              src="/assets/features/order/integration1.svg"
              alt="Insights"
              variants={fadeInLeft}
              initial="hidden"
              animate={inViewInsights ? "visible" : "hidden"}
              style={ismedium ? { width: "100%" } : {}}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              variants={fadeInRight}
              initial="hidden"
              animate={inViewInsights ? "visible" : "hidden"}
            >
              <Typography mb={2} variant="h6" sx={{ fontWeight: 600 }}>
                Egora’s Order Management System works hand-in-hand with other
                modules for a complete restaurant solution
              </Typography>
              <List>
                {[
                  "Point of Sale (POS) System.",
                  "Kitchen Display System (KDS).",
                  "Inventory and Warehouse Management.",
                  "Payment Gateways and Digital Wallets.",
                  "Customer Engagement Tools.",
                  "Delivery Management.",
                  "Staff Management.",
                ].map((text) => (
                  <ListItem key={text}>
                    <ListItemIcon>{checkIcon}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItem>
                ))}
              </List>
            </motion.div>
          </Grid>
        </Grid>
      </Box>

      <Box mb={{ xs: 2, sm: 6 }} ref={insightsRef}>
        {/* <Typography variant="h1" sx={{ color: "#F68528", fontWeight: 700 }}>
          Seamless Integration {isMobile ? " " : <br />} with Egora Ecosystem
        </Typography> */}
        <Grid container spacing={3} alignItems="center" mt={{ xs: 0, sm: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h1" sx={{ color: "#F68528", fontWeight: 700 }}>
              Built for Every {isMobile ? " " : <br />} Restaurants Type
            </Typography>
            <motion.div
              variants={fadeInRight}
              initial="hidden"
              animate={inViewInsights ? "visible" : "hidden"}
            >
              {/* <Typography mb={2} variant="h6" sx={{ fontWeight: 600 }}>
                Egora’s Order Management System works hand-in-hand with other
                modules for a complete restaurant solution
              </Typography> */}
              <List>
                {[
                  "Fine Dining Restaurants.",
                  "Fast Food Chains.",
                  "Cafes and Coffee Shops.",
                  "Bakeries.",
                  "Cloud Kitchens.",
                  "Food Trucks.",
                  "Multi-Station Commercial Kitchens.",
                ].map((text) => (
                  <ListItem key={text}>
                    <ListItemIcon>{checkIcon}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItem>
                ))}
              </List>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.img
              src="/assets/features/warehouse/integration2.png"
              alt="Insights"
              variants={fadeInLeft}
              initial="hidden"
              animate={inViewInsights ? "visible" : "hidden"}
              style={ismedium ? { width: "100%" } : {}}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
